import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem, Typography } from '@mui/material';
import { updateGroup } from '../../../../repository/UserDAO';
import { useUserContext } from '../../../../context_providers/user_context/UserProvider';
import LoadingData from '../../../../components/loading/LoadingData';
import { useToast } from '../../../../context_providers/toast_context/ToastContext';
import COLORS from '../../../../resources/style/Themes';
import BaseModal from '../../../../components/modals/BaseModal';
import { useTranslation } from 'react-i18next';
import {
  StringKeys,
  SuccessStringKeys,
} from '../../../../resources/strings/StringKeys';

function UpdateGroupModal({ show, onHide, currentOrgData, initialGroups }) {
  const { bearerToken } = useUserContext();
  const [selectedGroup, setSelectedGroup] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const { showErrorToast, showSuccessToast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (show) {
      setSelectedGroup('');
    }
  }, [show]);

  const handleUpdateGroup = async () => {
    if (!selectedGroup) {
      showErrorToast(t(StringKeys.PLEASE_SELECT_A_GROUP));
      return;
    }

    setLoading(true);
    try {
      /** @type {import('../../../../../generated-client/models').OrgUserUpdateGroup} */
      const updateData = {
        org_code: currentOrgData.org_code,
        auth_id: currentOrgData.auth_id,
        group_name: selectedGroup,
        organization_azure_id: currentOrgData.organization_azure_id,
      };

      await updateGroup(updateData);

      startCountdown();
      showSuccessToast(t(SuccessStringKeys.SUCCESSFULLY_UPDATED_GROUP));
    } catch (error) {
      showErrorToast(t(StringKeys.SOMETHING_WENT_WRONG));
    } finally {
      setLoading(false);
    }
  };

  const startCountdown = () => {
    setCountdown(5);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleClose = () => {
    if (countdown === null) {
      onHide();
    }
  };

  return (
    <>
      <BaseModal
        footerContent={null}
        open={show}
        onClose={handleClose}
        title={t(StringKeys.CHANGE_GROUP)}
        onSubmit={handleUpdateGroup}
        submitButtonText={t(StringKeys.SUBMIT)}
        size="sm"
        enableEnterKey={true}
        showFooter={countdown === null}
      >
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            displayEmpty
            disabled={countdown !== null}
          >
            <MenuItem value="" disabled>
              {t(StringKeys.SELECT_A_GROUP)}
            </MenuItem>
            {Array.isArray(initialGroups) &&
              initialGroups.map((group, index) => (
                <MenuItem key={index} value={group}>
                  {group}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        {countdown !== null && (
          <Typography
            sx={{ mb: 2, textAlign: 'center', color: COLORS.SAFEGUARD_BLUE }}
          >
            {t(StringKeys.SUCCESS_PAGE_WILL_REFRESH_IN_COUNTDOWN, {
              countdown,
            })}
          </Typography>
        )}
      </BaseModal>
      <LoadingData show={loading} />
    </>
  );
}

export default UpdateGroupModal;
